module.exports = __webpack_public_path__ + "img/profile-avatar.c7d9d2c2.svg";